/**
 * Types de RDV client de l'agenda (un par couleur Google Agenda) : fichier de réglage.
 *
 * - durationMinutes : durée proposée par défaut à la prise de RDV (la fin reste modifiable).
 *   Estimée sur les RDV réels d'octobre 2025 à septembre 2026 : à ajuster au besoin.
 * - prestation : prestation de la demande qui correspond au type. Si le type choisi ne correspond
 *   plus à la prestation, la fenêtre de RDV propose de la mettre à jour (HubSpot s'en sert pour
 *   l'e-mail de confirmation). null = pas d'équivalent, rien n'est proposé ; STAGE = garde le stage
 *   déjà indiqué dans la demande (1, 2 ou 3), stage 1 à défaut.
 */
export const STAGE = 'stage'

export const APPOINTMENT_TYPES = [
    { id: '9', name: 'Stage 0', color: '#3F51B5', durationMinutes: 60, prestation: 'Reprogrammation stage 0' },
    { id: '7', name: 'Stage 1/2/3', color: '#039BE5', durationMinutes: 120, prestation: STAGE },
    { id: '2', name: 'FlexFuel', color: '#33B679', durationMinutes: 120, prestation: 'Conversion E85' },
    { id: '6', name: 'FlexFuel+', color: '#F4511E', durationMinutes: 120, prestation: 'Conversion E85+' },
    { id: '11', name: 'SAV', color: '#D50000', durationMinutes: 60, prestation: null },
    { id: '3', name: 'Passage au banc', color: '#8E24AA', durationMinutes: 60, prestation: 'Passage au banc' },
    { id: '5', name: 'Mécanique', color: '#F6BF26', durationMinutes: 180, prestation: 'Entretien' },
    { id: '8', name: 'Esthétique', color: '#616161', durationMinutes: 210, prestation: 'Esthétique' },
    { id: '12', name: 'Remise Origine', color: '#7B3F00', durationMinutes: 60, prestation: null },
]

// Durée utilisée si un type n'est pas trouvé
export const DEFAULT_APPOINTMENT_DURATION_MINUTES = 120

export const findAppointmentType = (id) => APPOINTMENT_TYPES.find((type) => type.id === String(id)) ?? null
